import {
    getPlan,
    getOneTimeSalesTemplate,
    getNetworkNodeDetails,
} from "@/http/customer/customer";

export default {
    namespaced: true,
    state: {
        networkNodeDetails: [],
        oneTimeSalesTemplate: {},
        planLists: [],
    },
    actions: {
        async setOneTimeSalesTemplate({ commit }) {
            const response = await getOneTimeSalesTemplate();
            commit("ONE_TIME_SALES_TEMPLATE", response.data);
            return response;
        },
        async setNetworkDetailsAction({ commit }) {
            const response = await getNetworkNodeDetails();
            commit("SET_NETWORK_DETAILS", response.data);
            return response;
        },
        async setPlansAction({ commit }, data) {
            const response = await getPlan(data);
            commit("SET_PLANS", response.data.planData);
            return response;
        },
    },
    mutations: {
        ONE_TIME_SALES_TEMPLATE(state, payload) {
            state.oneTimeSalesTemplate = payload;
        },
        SET_NETWORK_DETAILS(state, payload) {
            state.networkNodeDetails = payload;
        },

        SET_PLANS(state, payload) {
            state.planLists = payload;
        },
    },
    getters: {
        getClientTickets(state) {
            return state.tickets;
        },

    },
};
